import { createRoute, Outlet } from "@tanstack/react-router";
import { appRoute } from "./parent-routes";
import TransmittalSearchForm from "../../modules/document-transmittal/pages/TransmittalSearchForm";
import TransmittalForm from "../../modules/document-transmittal/pages/TransmittalForm";

const documentTransmittalRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "document-transmittal",
  component: Outlet,
  staticData: {
    handle: { title: "Document Transmittal" },
  },
});

const documentTransmittalSearchIndexRoute = createRoute({
  getParentRoute: () => documentTransmittalRoute,
  path: "/",
  component: TransmittalSearchForm,
  staticData: {
    handle: { title: "Document Transmittal" },
  },
});

const documentTransmittalCreateRoute = createRoute({
  getParentRoute: () => documentTransmittalRoute,
  path: "create",
  component: TransmittalForm,
  staticData: {
    handle: { title: "Create Transmittal Request", action: "create" },
  },
});

const documentTransmittalDisplayRoute = createRoute({
  getParentRoute: () => documentTransmittalRoute,
  path: "$id/display",
  component: TransmittalForm,
  staticData: {
    handle: { title: "View Transmittal Request", action: "display" },
  },
});

const documentTransmittalEditRoute = createRoute({
  getParentRoute: () => documentTransmittalRoute,
  path: "$id/edit",
  component: TransmittalForm,
  staticData: {
    handle: { title: "Edit Transmittal Request", action: "edit" },
  },
});

const documentTransmittalRouteTree = documentTransmittalRoute.addChildren([
  documentTransmittalSearchIndexRoute,
  documentTransmittalCreateRoute,
  documentTransmittalDisplayRoute,
  documentTransmittalEditRoute,
]);

export default documentTransmittalRouteTree;
